export default (string, form) => {
	if (string && form && form.calc) {
		const changes = [
			{ from: '{bmi_value}', to: form.calc.bmi_value },
			{ from: '{bmi_title}', to: form.calc.bmi_title },
			{
				from: '{bmi_weight}',
				to: form.metric
					? form.calc.bmi_weight
					: form.calc.bmi_weight &&
					  form.calc.bmi_weight
							.split('-')
							.map(item => Math.round(Number(item) * 2.20462262185))
							.join('-'),
			},
			{ from: '{tdee}', to: form.calc.tdee },
			{ from: '{tdee_carbs}', to: form.calc.tdee_carbs },
			{ from: '{tdee_proteins}', to: form.calc.tdee_proteins },
			{ from: '{tdee_fats}', to: form.calc.tdee_fats },
			{ from: '{water}', to: form.calc.water },
			{ from: '{steps}', to: form.calc.steps },
			{ from: '{lbm}', to: form.metric ? form.calc.lbm : Math.round(Number(form.calc.lbm) * 2.20462262185) },
		];
		changes.map((item, index) => {
			string = string.split(item.from).join(item.to);
			return true;
		});
	}
	return string;
};
